import { CommandInput, useCommandState } from '@nesso/ui/primitives/command';

type Props = {
    value: string;
    onValueChange: (value: string) => void;
    onCreateCustomCode: () => void;
};

// `useCommandState` only resolves inside `Command`'s own tree, so the Enter-to-create handler
// has to live here rather than in the parent, which renders `Command` and sits outside it.
export function SaveServiceCodePickerSearchInput({
    value,
    onValueChange,
    onCreateCustomCode,
}: Props) {
    const canCreateCustomCode =
        useCommandState((state) => state.filtered.count === 0) && value.trim() !== '';

    return (
        <CommandInput
            value={value}
            onValueChange={onValueChange}
            placeholder="Search or create a new service code"
            onKeyDown={(event) => {
                // Enter only confirms an IME composition (Safari reports it as keyCode 229), as cmdk's root also checks.
                const isComposing = event.nativeEvent.isComposing || event.keyCode === 229;
                if (event.key === 'Enter' && canCreateCustomCode && !isComposing) {
                    event.preventDefault();
                    onCreateCustomCode();
                }
            }}
        />
    );
}
